<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.69619 4.59727C8.67999 4.61351 8.66364 4.62991 8.6471 4.64644L8.6471 4.64645L4.03881 9.25473C4.02779 9.26575 4.01684 9.27668 4.00598 9.28752C3.84351 9.44965 3.69968 9.59317 3.59832 9.7722C3.49695 9.95123 3.44788 10.1484 3.39244 10.3711C3.38874 10.386 3.385 10.401 3.38122 10.4162L3.05103 11.7369C3.04881 11.7458 3.04658 11.7547 3.04434 11.7636C3.0051 11.9203 2.96319 12.0877 2.94944 12.2282C2.93431 12.3829 2.93783 12.644 3.14725 12.8534C3.35666 13.0628 3.61771 13.0663 3.77244 13.0512C3.91298 13.0375 4.08032 12.9955 4.23701 12.9563C4.24595 12.9541 4.25485 12.9518 4.2637 12.9496L5.58449 12.6194C5.59961 12.6156 5.61462 12.6119 5.62951 12.6082C5.85224 12.5528 6.04942 12.5037 6.22845 12.4023C6.40748 12.301 6.55101 12.1571 6.71313 11.9947C6.72397 11.9838 6.7349 11.9729 6.74592 11.9618L11.3542 7.35355C11.3707 7.33701 11.3871 7.32065 11.4034 7.30446C11.6268 7.08162 11.82 6.88892 11.9305 6.66602C12.1384 6.24636 12.1384 5.75364 11.9305 5.33398L11.4825 5.55598L11.9305 5.33398C11.82 5.11108 11.6268 4.91838 11.4034 4.69555C11.3871 4.67935 11.3707 4.66299 11.3542 4.64645C11.3528 4.64506 11.3514 4.64368 11.3501 4.64229C11.3349 4.62716 11.32 4.61215 11.3051 4.59727C11.0823 4.37384 10.8896 4.18064 10.6667 4.07019C10.247 3.86222 9.75429 3.86222 9.33463 4.07019C9.11173 4.18064 8.91903 4.37384 8.69619 4.59727Z"
      stroke="url(#paint0_linear_3490_12275)"
      class="stroke"
    />
    <path
      d="M8.33398 4.99935L10.334 3.66602L12.334 5.66602L11.0007 7.66602L8.33398 4.99935Z"
      fill="url(#paint1_linear_3490_12275)"
      class="stroke"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3490_12275"
        x1="7.66732"
        y1="4"
        x2="7.66732"
        y2="12.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3490_12275"
        x1="10.334"
        y1="3.66602"
        x2="10.334"
        y2="7.66602"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss">
.edit-color {
  svg .stroke {
    width: 12px;
    height: 12px;
    stroke: gray;
  }
}

.text-red {
  svg .stroke {
    width: 12px;
    height: 12px;
    stroke: #df252a;
  }
}
</style>
